import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=8ab64b76&lang=css"

const __exports__ = script;

export default __exports__
import QTd from 'quasar/src/components/table/QTd.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import qInstall from "../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTd,QTable,QVirtualScroll});
